import { checkSession } from "@features/auth";
import { preloadQuery } from "@relay";
import { createFileRoute, redirect } from "@tanstack/react-router";
import type { ended_reservationIdQuery } from "../swap/__generated__/ended_reservationIdQuery.graphql";
import { EndedRentalPage, query } from "../swap/ended.$reservationId";

export const Route = createFileRoute("/$hubMetaName/lock/ended/$reservationId")({
	beforeLoad: () => {
		document.title = "bacehub | Lock";
	},
	component: RouteComponent,
	loader: async (ctx) => {
		if (!(await checkSession())) {
			throw redirect({
				to: "/auth",
				search: { redirectToPath: `/${ctx.params.hubMetaName}/lock${ctx.location.searchStr}` },
			});
		}
		return preloadQuery<ended_reservationIdQuery>(ctx.context.relayEnvironment, query, {
			hubName: ctx.params.hubMetaName,
			reservationId: ctx.params.reservationId,
		});
	},
});

function RouteComponent() {
	return <EndedRentalPage queryRef={Route.useLoaderData()} hubMetaName={Route.useParams().hubMetaName} service="LOCK_B2C" />;
}
